<script lang="ts">
  import MazeDisplay from "./MazeDisplay.svelte";
  import { onDestroy } from "svelte";
  import { speed } from "./stores";
  import type Maze from "./maze";

  export let maze: Maze;
  export let code;

  let world: Maze = maze.clone();

  let interval;
  let simulating = false;

  let behaviour, x, y, stones;

  onReset();

  function parseCode(code) {
    try {
      return new Function(code)();
    } catch (e) {
      return () => "syntax error while parsing code";
    }
  }

  function onSimulate() {
    if (!simulating) {
      simulating = true;

      interval = setInterval(() => {
        step();
      }, $speed);
    } else {
      stopSimulation();
    }
  }

  function stopSimulation() {
    simulating = false;
    clearInterval(interval);
  }

  onDestroy(() => stopSimulation());

  function onReset() {
    behaviour = parseCode(code);

    world = maze.clone();
    const playerPosition = world.findPlayer();
    x = playerPosition[0];
    y = playerPosition[1];
    stones = [true, true];
  }

  function step() {
    const input = {
      north: false,
      south: false,
      west: false,
      east: false,
      hasStone1: false,
      hasStone2: false,
      seeStone1: false,
      seeStone2: false,
      uniqueNW: world.isUnique(x - 1, y),
      uniqueNE: world.isUnique(x, y),
      uniqueSW: world.isUnique(x - 1, y + 1),
      uniqueSE: world.isUnique(x, y + 1),
    };

    if (world.grid[y - 1][x] == 1) input.north = true;
    if (world.grid[y + 1][x] == 1) input.south = true;
    if (world.grid[y][x - 1] == 1) input.west = true;
    if (world.grid[y][x + 1] == 1) input.east = true;
    if (stones[0]) input.hasStone1 = true;
    if (stones[1]) input.hasStone2 = true;
    if ((world.grid[y][x] & 4) != 0) input.seeStone1 = true;
    if ((world.grid[y][x] & 8) != 0) input.seeStone2 = true;

    const action = behaviour(input);

    if (action == "north" && !input.north) {
      world.grid[y][x] ^= 2;
      if (world.grid[y - 1][x] == 3) {
        alert("Finished!");
        stopSimulation();
      }
      world.grid[y - 1][x] ^= 2;
      y -= 1;
    } else if (action == "south" && !input.south) {
      world.grid[y][x] ^= 2;
      if (world.grid[y + 1][x] == 3) {
        alert("Finished!");
        stopSimulation();
      }
      world.grid[y + 1][x] ^= 2;
      y += 1;
    } else if (action == "west" && !input.west) {
      world.grid[y][x] ^= 2;
      if (world.grid[y][x - 1] == 3) {
        alert("Finished!");
        stopSimulation();
      }
      world.grid[y][x - 1] ^= 2;
      x -= 1;
    } else if (action == "east" && !input.east) {
      world.grid[y][x] ^= 2;
      if (world.grid[y][x + 1] == 3) {
        alert("Finished!");
        stopSimulation();
      }
      world.grid[y][x + 1] ^= 2;
      x += 1;
    } else if (action == "place1") {
      if (!stones[0]) {
        alert("Cannot place stone (1) that it does not have!");
        stopSimulation();
      }
      stones[0] = false;
      world.grid[y][x] |= 4;
    } else if (action == "place2") {
      if (!stones[1]) {
        alert("Cannot place stone (2) that it does not have!");
        stopSimulation();
      }
      stones[1] = false;
      world.grid[y][x] |= 8;
    } else if (action == "pickup1") {
      if ((world.grid[y][x] & 4) == 0) {
        alert("Cannot pick up stone 1!");
        stopSimulation();
      }
      stones[0] = true;
      world.grid[y][x] ^= 4;
    } else if (action == "pickup2") {
      if ((world.grid[y][x] & 8) == 0) {
        alert("Cannot pick up stone 2!");
        stopSimulation();
      }
      stones[1] = true;
      world.grid[y][x] ^= 8;
    } else {
      alert(`Behaviour chose invalid action "${action}"!`);
      stopSimulation();
    }
  }

  function onChangeSpeed() {
    const newSpeed = prompt("Enter time (ms) between steps");
    if (!newSpeed) return;
    $speed = parseInt(newSpeed);
  }
</script>

<div class="my-2">
  <div class="btn-group">
    <button class="btn btn-primary" on:click={onSimulate}>
      {#if simulating}
        <span class="spinner-border spinner-border-sm" />
        Pause
      {:else}
        Start
      {/if}
    </button>
    <button class="btn btn-secondary" on:click={step}>Step</button>
    <button class="btn btn-secondary" on:click={onReset} disabled={simulating}
      >Reset</button
    >
    <button
      class="btn btn-secondary"
      on:click={onChangeSpeed}
      disabled={simulating}>Change speed ({$speed} ms)</button
    >
  </div>
</div>

<MazeDisplay maze={world} />
